import React from "react";
import { tsToDate } from "../../helpers/date.helper";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import {
  setHrEventId,
  setHrMarketId,
  setIsDetailedGroupName,
  setIsEventDetailed,
  setIsNavigationID,
  setIsNavigationName,
} from "../../store/navigationHeaderMenu/navigationHeaderMenu.slice";
import { requestSportPageEvent } from "../../store/sportPageEvent/sportPageEvent.thunks";
import { requestCompetition } from "../../store/competitions/competitions.thunks";
import { requestHomeAllCompetition } from "../../store/homeMarketEvents/homeMarketEvents.thunks";
import { UNICON_THEME } from "../../config/api.config";

const OpenBetsItem = ({
  timeSettings,
  bet,
  isEvent,
  isUnmatched = false,
  cancel,
  redirect = false,
}) => {
  // const history = useHistory();
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const getTitle = () => {
    const isBack = bet.is_back == 1;
    const isFancy = bet.is_fancy == 1;
    const text = isFancy
      ? `${bet.market_name} (${bet.odds}) - ${isBack ? "Yes" : "No"}`
      : isBack
      ? "Back"
      : "Lay";
    const profit = isFancy ? bet.profit.toFixed(2) : bet.profit.toFixed(2);

    return (
      <div
        className={` font-medium underline capitalize text-sm ${
          isBack
            ? "text-text_ChangeAnimationBack"
            : "text-text_ChangeAnimationLay"
        } `}
      >
        {text} {!isFancy && bet.selection_name} for{" "}
        {isBack ? bet.stack : bet.liability} @ {bet?.odds}{" "}
        {isBack ? "to win" : "liability"} {profit}.
      </div>
    );
  };

  const redirectEvent = () => {
    dispatch(setIsDetailedGroupName(bet?.series_name));
    dispatch(setIsEventDetailed(false));
    const data = {
      sport_id: bet?.sport_id,
    };

    dispatch(requestHomeAllCompetition(data));

    if (bet?.sport_id === "7" || bet?.sport_id === "4339") {
      dispatch(setIsNavigationID(bet?.sport_id));
      dispatch(
        setIsNavigationName(
          bet?.sport_id === "7" ? "Horse Racing" : "Greyhound Racing"
        )
      );
      dispatch(setHrEventId(bet.match_id));
      dispatch(setHrMarketId(bet?.market_id));

      navigate(bet?.sport_id === "7" ? "/horse-racing" : "/greyhound-racing");
      return;
    }
    navigate(`/event-page/${bet.sport_id}/${bet.match_id}/${bet.match_name}`);
  };

  return location.pathname.includes("open-bets") ? (
    <>
      <div className=" bg-bg_Quaternary rounded-md divide-y  divide-[#676767] w-full shadow mb-1">
        <div
          id="eventHeader"
          className="font-semibold   px-3 py-2"
          onClick={() => {
            if (redirect) redirectEvent();
          }}
        >
          {getTitle()}
        </div>
        <div className="px-3 py-2 text-text_Ternary  uppercase font-lato flex flex-col">
          <span className=" font-semibold text-xs ">{bet?.market_name}</span>
          <span className=" font-normal text-xs">{bet?.match_name}</span>
        </div>
        <div
          id="tiem_Date_of_order_0_1730174400000"
          className={` text-xs px-3 py-2 text-center ${UNICON_THEME ? "text-black bg-[var(--color-bg-ternary8)]": "text-white bg-bg_color_tertiary1 "} font-lato font-normal rounded-b-md `}
        >
          PLACED - {tsToDate(bet.createdAt, timeSettings.timeZoneName)}
        </div>
      </div>
    </>
  ) : (
    <>
      <div className=" bg-bg_Quaternary rounded-md mb-1 px-4 w-full py-3 box-shadow: 0 20px 25px -5px rgba(0,0,0,0.1), 0 8px 10px -6px rgba(0,0,0,0.1);">
        <div
          id="eventHeader"
          className=" font-lato-bold font-semibold"
          onClick={() => {
            if (redirect) redirectEvent();
          }}
        >
          {getTitle()}
        </div>
        <div className=" font-normal text-text_Ternary  capitalize text-xs font-lato">
          {bet.is_fancy == 1 ? "Fancy" : bet.market_name}
        </div>
        <div
          id="tiem_Date_of_order_0_1730174400000"
          className=" text-xs font-lato font-normal text-white"
        >
          <strong>Placed : </strong>
          <span>{tsToDate(bet.createdAt, timeSettings.timeZoneName)}</span>
        </div>
      </div>
    </>
  );
};

export default OpenBetsItem;
